import Spinner from './Spinner';

export interface LoadingScreenProps {
  /** Optional message to display below the spinner */
  message?: string;
}

/**
 * Full-page loading screen component.
 * WP-AUTH-12: Used by AuthProvider during auth initialization
 * to prevent flash redirects to login page.
 */
export default function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-gray-50"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <Spinner size="lg" />
      <p className="mt-4 text-gray-600 text-sm">{message}</p>
    </div>
  );
}
